window.FichaFinanceiraView = Backbone.Marionette.CompositeView.extend({
    template: "#template-ficha-financeira",

    initialize: function(options) {
        this.app = options.app,
            this.model = options.model;
    }
});